import { Grid } from '@mui/material';
import React, { useEffect } from 'react';

import { ChipRow, MainGrid } from './Profile.styles';
import { Chip } from '../../components/atoms/Chip';
import { PageContainer } from '../../components/atoms/PageContainer';
import { Typography, TypographyVariantProps } from '../../components/atoms/Typography';
import { useGetCurrentUser } from '../../queries/user-query';

export const Profile: React.FC = () => {
  const getCurrentUser = useGetCurrentUser();

  // Zones are assigned by an administrator on the user configuration screen
  // (Configure > Users > Edit). This page is read-only for everyone, so we
  // just refresh the current-user record on mount to reflect any admin-side
  // changes to the assigned zones.
  useEffect(() => {
    getCurrentUser.refetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps -- mount-only refresh; refetch identity is stable
  }, []);

  // Guard against the legacy [''] sentinel that older saves used to represent
  // "no zones", so it never renders as a blank chip or counts as one zone.
  const myZones = (getCurrentUser.data?.config?.myZones ?? []).filter((zone) => zone !== '');

  return (
    <PageContainer>
      <Typography variant={TypographyVariantProps.H5} fontWeight={600}>
        Profile
      </Typography>
      <MainGrid container>
        <Grid>
          <Typography variant={TypographyVariantProps.H6}>My Zones</Typography>
          {myZones.length > 0 ? (
            <ChipRow>
              {myZones.map((zone) => (
                <Chip key={zone} label={zone} />
              ))}
            </ChipRow>
          ) : (
            <Typography variant={TypographyVariantProps.Body2}>No zones assigned.</Typography>
          )}
        </Grid>
      </MainGrid>
    </PageContainer>
  );
};
